import {CommonResponse, GetParamsType, instance} from "./API"
import {AxiosResponse} from "axios"
import {filterToString} from "../helps/filterToString"
import {UnregisterPSLeakDevicesResponse} from "../models/response"

export const unregisterPsLeakDeviceApi = {
    getDevices(params?: GetParamsType & {search?: string}): Promise<CommonResponse<UnregisterPSLeakDevicesResponse>> {
        const paramsString = filterToString(params)
        return instance.get(`UnregisterPSLeakDevice${paramsString}`, {signal: params?.controller?.signal}).then((res: AxiosResponse) => res.data)
    },
}
